import React, { SVGProps } from "react";
import clsx from "clsx";
import { getTailwindColorClass, Intent } from "../../../common/enums";
import styles from "./spinner.module.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
interface SpinnerProps extends React.SVGProps<React.ReactSVGElement> {
  variant?: Intent;
  size?: number;
  color?: string;
  circleSize?: number;
  circleStyle?: string;
}

const noOFDiv = [1, 2, 3, 4, 5, 6, 7];

const Spinner = ({
  className,
  variant,
  size = 10,
  circleStyle = "bg-primary",
  circleSize = 1.5,
}: SpinnerProps) => {
  return (
    <div className={clsx(`inline-block`, className)}>
      <div
        className={clsx(
          `w-${size} h-${size} mb-6 mx-auto`,
          styles.wrapper,
          className
        )}
      >
        {noOFDiv.map((div) => (
          <div key={div} className={clsx(`w-${size} h-${size}`, styles.loader)}>
            <div
              className={clsx(
                `rounded-full w-${circleSize} h-${circleSize} ${
                  variant && `bg-${getTailwindColorClass(variant)}`
                }`,
                styles.element,
                circleStyle
              )}
            ></div>
          </div>
        ))}
      </div>
      <span
        className={clsx(
          {
            "text-primary": !className?.includes("text-"),
          },

          `text-lg font-semibold tracking-widest ${
            variant && `text-${getTailwindColorClass(variant)}`
          }`
        )}
      >
        Please Wait
      </span>
    </div>
  );
};

export const FullPageSpinner = () => {
  return (
    <div className="w-screen h-screen flex bg-white items-center justify-center absolute z-50 top-0 left-0">
      <Spinner />
    </div>
  );
};

export const ButtonSpinner = ({
  color = "#fff",
  size = 2,
}: {
  color?: string;
  size?: number;
}) => {
  const Spinner = styled(LoadingOutlined)`
    animation-duration: 0.5s;
    font-size: ${size}rem;
    color: ${color};
  `;

  const antIcon = <Spinner className="text-warning" />;
  return <Spin indicator={antIcon} />;
};

export default Spinner;
